const commerceApiUrl = String(
  import.meta.env.VITE_COMMERCE_API_URL || "http://127.0.0.1:8791"
).replace(/\/$/, "");

async function getPublicJson(url, { signal, errorMessage }) {
  const response = await fetch(url, {
    method: "GET",
    headers: { Accept: "application/json" },
    signal,
  });

  let result;
  try {
    result = await response.json();
  } catch {
    throw new Error("A loja retornou uma resposta inválida.");
  }

  if (!response.ok) {
    const error = new Error(result?.error || errorMessage);
    error.status = response.status;
    throw error;
  }

  return result?.data;
}

export async function fetchCatalog(
  storeSlug,
  { page = 1, limit = 12, signal } = {}
) {
  const path = `/v1/storefront/stores/${encodeURIComponent(
    storeSlug
  )}/products`;
  const url = new URL(`${commerceApiUrl}${path}`);
  url.searchParams.set("page", String(page));
  url.searchParams.set("limit", String(limit));

  return getPublicJson(url, {
    signal,
    errorMessage: "Não foi possível carregar os produtos.",
  });
}

export function fetchProduct(storeSlug, productHandle, { signal } = {}) {
  const path = `/v1/storefront/stores/${encodeURIComponent(
    storeSlug
  )}/products/${encodeURIComponent(productHandle)}`;
  return getPublicJson(`${commerceApiUrl}${path}`, {
    signal,
    errorMessage: "Não foi possível carregar o produto.",
  });
}

export async function prepareCheckout(
  storeSlug,
  items,
  { idempotencyKey, signal } = {}
) {
  const path = `/v1/storefront/stores/${encodeURIComponent(
    storeSlug
  )}/checkout/prepare`;
  const response = await fetch(`${commerceApiUrl}${path}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Idempotency-Key": idempotencyKey,
    },
    body: JSON.stringify({
      items: items.map((item) => ({
        variantId: item.variantId,
        quantity: Number(item.quantity),
      })),
    }),
    signal,
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(
      result?.details
        ? `${result.error || "Não foi possível iniciar o checkout."}: ${result.details}`
        : result?.error || "Não foi possível iniciar o checkout."
    );
    error.status = response.status;
    error.code = result?.code;
    throw error;
  }
  return result.data;
}
